var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalanceBoxIconD2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 121,
    viewBox: "0 0 107 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1956_152949)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.0279 121.001C93.769 121.001 107.956 117.147 120.37 109.817C122.756 108.406 123.41 105.367 121.786 103.179L116.153 95.604C114.688 93.6344 111.876 93.0663 109.708 94.3162C100.471 99.6569 89.9575 102.46 79.0279 102.46C68.0983 102.46 57.5845 99.6569 48.3577 94.3162C46.1896 93.0663 43.378 93.625 41.9128 95.604L36.2797 103.179C34.6561 105.367 35.2996 108.406 37.6954 109.817C50.11 117.147 64.2967 121.001 79.0378 121.001H79.0279Z",
    fill: "#131A2D",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2509 89.5619L28.8442 83.7762C30.8143 82.2706 31.2697 79.5624 29.854 77.5738C23.1121 68.1424 19.5679 57.1676 19.5679 45.5867C19.5679 35.1421 22.4983 25.0763 28.0819 16.2415C29.3887 14.1677 28.8046 11.4785 26.7355 10.077L18.8155 4.689C16.5286 3.13604 13.3507 3.76101 11.8756 6.0431C4.21296 17.9175 0.183666 31.487 0.183666 45.5867C0.183666 60.9269 5.13366 76.0019 14.2219 88.5487C15.8257 90.7645 19.0432 91.2474 21.2509 89.5619Z",
    fill: "#131A2D",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.027 83.3867C57.2003 83.3867 39.5062 66.4625 39.5062 45.5854C39.5062 24.7084 57.2003 7.78418 79.027 7.78418C100.854 7.78418 118.548 24.7084 118.548 45.5854C118.548 66.4625 100.854 83.3867 79.027 83.3867Z",
    fill: "#131A2D",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1956_152949"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107 0H0V121H107V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalanceBoxIconD2);
export default __webpack_public_path__ + "static/media/balance-box-icon-d2.57b3e1ea371b627f4740f65f208b5574.svg";
export { ForwardRef as ReactComponent };